import Breadcrumb from '../components/Breadcrumb';
import NewsSection from '../components/NewsSection';
// import VisitTracker from '../components/VisitTracker';

const Home = () => {
  return (
    <>
    <div className="md:mx-20 mx-auto px-4 py-8">
      <Breadcrumb />
      <NewsSection category="india" />
      <NewsSection category="world" />
      <NewsSection category="telangana" />
      {/* <VisitTracker /> */}
    </div>
    </>
  );
};

export default Home;